<template>
  <Content id="BatchInputLog">
    <div slot="search">
      <Form :label-width="75" :model="search">
        <Row>
          <Col><FormItem label="文件名称"><Input v-model="search.fileName"/></FormItem></Col>
          <Col>
            <FormItem label="结果" :label-width="45">
              <Select v-model="search.result" style="width: 100%;">
                <Option v-for="item in enums.exportResults" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="导入类型">
              <Select v-model="search.type" style="width: 100%;">
                <Option v-for="item in typeList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="日期">
              <DatePicker  style="width:114px ;" type="date" :editable="false" placeholder="开始日期" format="yyyy-MM-dd" v-model="search.startDate"  @on-change="changestart"></DatePicker>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd" v-model="search.endDate" @on-change="changeend"></DatePicker>
            </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed="left" align="center" prop="schoolName" label="体检学校名称" show-overflow-tooltip  min-width="150"/>
      <el-table-column align="center" prop="type" label="业务类型" min-width="300">
        <template slot-scope="{row}" slot="type">
          {{ enums.sourcesList.filter(u => u.value === row.type)[0].label}}
        </template>
      </el-table-column>
      <el-table-column fixed="left" align="center" prop="result" label="结果" min-width="300">
        <template slot-scope="{row}" slot="result">
          {{ enums.sourcesList.filter(u => u.value === row.result)[0].label}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="oprator" label="操作员" min-width="150"/>
      <el-table-column align="center" prop="createTime" label="操作时间" min-width="100"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="80">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="downloadFile(row)">文件下载</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 20, 40, 80]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

  </Content>
</template>
<script>
import {_page,_download} from "@/services/inputOutput/inputLog.js";
import {mixins} from "@/mixins/index.js";
import {enums} from "@/services/enums";
export default {
  name: "BatchInputLog",
  mixins: [mixins],
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        fileName: "",
        startDate:"",
        endDate:"",
        result:"",
        type:"",
      },
      typeList:[
        {label: '全部', value: ""},
        {label: '班级导入', value: 1},
        {label: '导入学生', value: 2},
        {label: '导入体检名单', value: 3},
        {label: '导入检验数据', value: 4},
        {label: '导入DR图片', value: 5},
        {label: '导入DR结果', value: 6},
      ],
      enums:enums,
      dataList: [],
      pageList:{
        currentPage:1,
        pageSize:10,
        total: 0,

      },
    };
  },
  watch: {
    '$route.path': {
      handler(newData, oldData) {
        if(newData && newData.length > 0 && newData === '/batch-input-log/page' && this.$userSession.checkInstitutionId()){
          this.handleDataList();
        }
      },
    }
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList(); // 获取列表数据
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode == 1){
          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        } else {
          this.$message.error(res.errmsg)
        }
      }).catch(() => {});
    },
    downloadFile(row){
      _download().then(res=>{
        if (res.errcode !== 1){
          this.$message.error(res.errmsg)
        }
      })
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    changestart(e) {
      this.search.startDate = e
    },
    changeend(e) {
      this.search.endDate = e
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}

</style>
